export const coerceDefaultNotional = (value: string): string | null =>
  value === '' || parseFloat(value) === 0 ? null : value;
